// Display when no date is selected.
export const EMPTY_DATE_DISPLAY = "dd/mm/yy";
export const EMPTY_DATE_TIME_DISPLAY = "dd/mm/yy HH:mm";
